import axios from 'axios'

import { poisIndexeddbStore, localstorageStore } from '../plugins/localforage'

import { shuffleArray } from '../utils/index'

import { favorites } from './favorites'

export const objects = {
  state: {
    pois: [],
    subCategories: ['hotel', 'restaurant', 'event', 'congress', 'offer'],
    ...favorites.state,
    defaultImages: {
      hero: require('@/assets/images/default-image.jpg'),
      cover: require('@/assets/images/cover-default-image.jpg'),
      lazy: require('@/assets/images/lazy-default-image.jpg'),
    },
  },

  mutations: {
    setPois(state, pois) {
      state.pois = pois
    },

    setPoi(state, poi) {
      state.pois.push(poi)
    },

    clearPois(state) {
      state.pois = []
    },
    ...favorites.mutations,
  },

  actions: {
    async checkIfMustSynchronize({ getters, rootState }) {
      try {
        if (!rootState.isOnline) return false
        const syncedTime = await localstorageStore.getItem('synced')

        const response = await axios({
          method: 'GET',
          url: getters.modificationEndpoint,
        })

        const { lastModified } = response.data

        if (!lastModified) return true

        return !(syncedTime && syncedTime > lastModified)
      } catch (err) {
        console.error('err', err)

        return true
      }
    },

    async fetchPoisFromLocal({ commit, dispatch, rootState }) {
      return new Promise(async (resolve, reject) => {
        try {
          let pois = []
          await poisIndexeddbStore.iterate((poi) => {
            pois.push(poi)
          })

          pois = await dispatch('sortPois', pois)

          commit('setPois', pois)

          commit('clearObjectsError')

          if (pois.length === 0 && !rootState.isOnline) commit('setObjectsError', 'errors.must-sync')
          resolve(pois)
        } catch (err) {
          commit('setObjectsError', 'errors.loading')
          reject()
        }
      })
    },

    async fetchPoiFromLocal({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        try {
          const poi = await poisIndexeddbStore.getItem(id)
          commit('setPoi', poi)
          commit('clearObjectsError')
          resolve(poi)
        } catch (err) {
          console.log('err', err)
          commit('setObjectsError', 'errors.loading')
          reject()
        }
      })
    },

    async fetchPoisFromApi({ commit, dispatch, getters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await axios.get(getters.poiEndpoint)

          let pois = response.data

          pois = await dispatch('sortPois', pois)

          await dispatch('storePoisToLocal', pois)

          commit('setPois', pois)
          commit('clearObjectsError')

          resolve(response.data)
        } catch (err) {
          console.log('err', err)
          commit('setObjectsError', 'errors.loading')
          await localstorageStore.setItem('synced', null)
          reject()
        }
      })
    },

    sortPois(context, pois) {
      const categoriesMapping = {
        hotel: 'hotel',
        congress: 'congress',
        event: 'eventAndRestaurant',
        restaurant: 'eventAndRestaurant',
      }

      const poisByCategory = {
        congress: [],
        eventAndRestaurant: [],
      }

      const hotels = []

      pois.forEach((poi) => {
        if (poi.venue_finder_sub_category) {
          const category = categoriesMapping[poi.venue_finder_sub_category]

          if (category === 'hotel') return hotels.push(poi)

          return poisByCategory[category].push(poi)
        }
      })

      const hotelsByCategory = []
      hotels.forEach((hotel) => {
        const { hotel_stars = 0, superior = false } = hotel.venue

        // small algorithm to separate each category :
        // 5sup => (5 * 2) + 1 = 11
        // 5 => (5 * 2) = 10
        // 4sup => (4* 2) + 1 = 9
        // ...
        const category = superior
          ? (hotel_stars * 2) + 1
          : hotel_stars * 2

        if (!hotelsByCategory[category]) hotelsByCategory[category] = []

        hotelsByCategory[category].push(hotel)
      })

      let sortedPois = []
      for (let category in hotelsByCategory.reverse()) {
        const shuffled = shuffleArray(hotelsByCategory[category])
        sortedPois = [...sortedPois, ...shuffled]
      }

      for (let category in poisByCategory) {
        const shuffled = shuffleArray(poisByCategory[category])
        sortedPois = [...sortedPois, ...shuffled]
      }

      return sortedPois
    },

    async fetchPoiFromApi({ commit, dispatch, getters }, id) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await axios.get(`${getters.poiEndpoint}/${id}`)

          const poi = response.data

          await dispatch('storePoiToLocal', poi)

          commit('setPoi', poi)
          commit('clearObjectsError')
          resolve(poi)
        } catch (err) {
          commit('setObjectsError', 'errors.loading')
          reject()
        }
      })
    },

    async storePoisToLocal(context, pois) {
      return new Promise(async (resolve, reject) => {
        try {
          for (let poi of pois) {
            if (!poi.venue_finder_sub_category) continue
            await poisIndexeddbStore.setItem(poi.id.toString(), poi)
          }

          // transform timestamp from ms to s
          const timestamp = Math.floor(new Date().getTime() / 1000)

          await localstorageStore.setItem('synced', timestamp)

          resolve()
        } catch (err) {
          await localstorageStore.setItem('synced', null)

          reject()
        }
      })
    },

    async storePoiToLocal(context, poi) {
      return new Promise(async (resolve, reject) => {
        try {
          await poisIndexeddbStore.setItem(poi.id.toString(), poi)

          resolve()
        } catch (err) {
          await localstorageStore.setItem('synced', null)

          reject()
        }
      })
    },
    ...favorites.actions,
  },

  getters: {
    ...favorites.getters,
    poiEndpoint(state, getters, rootState) {
      return `${rootState.apiEndoint}/pois`
    },
    modificationEndpoint(state, getters, rootState) {
      return `${rootState.apiEndoint}/modifications`
    }
  },
}
